import type { LicensePermission, Session } from '../types'

export function can(session: Pick<Session, 'permissions'> | undefined, permission: LicensePermission) {
  return session?.permissions?.includes(permission) ?? false
}
